// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-orange {
  font-family: "Montserrat", "Roboto", "sans-serif";
  border-radius: 5px !important;
  font-weight: 600 !important;
  font-size: 18px !important;
  padding: 10px 18px !important;
  cursor: pointer;
}
.btn-orange:disabled {
  background-color: rgb(204, 203, 203) !important;
  cursor: not-allowed !important;
  border: none !important;
}
.btn-orange {
  background-color: #ff611d !important;
  color: #ffffff !important;
  border: 1px solid #ff611d !important;
}

.btn-orange-outline {
  font-family: "Montserrat", "Roboto", "sans-serif";
  border-radius: 5px !important;
  font-weight: 600 !important;
  font-size: 18px !important;
  padding: 10px 18px !important;
  cursor: pointer;
}
.btn-orange-outline:disabled {
  background-color: rgb(204, 203, 203) !important;
  cursor: not-allowed !important;
  border: none !important;
}
.btn-orange-outline {
  background-color: #ffffff !important;
  color: #ff611d !important;
  border: 1px solid #ff611d !important;
}

.btn-black {
  font-family: "Montserrat", "Roboto", "sans-serif";
  border-radius: 5px !important;
  font-weight: 600 !important;
  font-size: 18px !important;
  padding: 10px 18px !important;
  cursor: pointer;
}
.btn-black:disabled {
  background-color: rgb(204, 203, 203) !important;
  cursor: not-allowed !important;
  border: none !important;
}
.btn-black {
  background-color: #333333 !important;
  color: #ffffff !important;
  border: 1px solid #333333 !important;
}

.btn-success {
  background-color: #299541 !important;
  font-family: "Montserrat", "Roboto", "sans-serif";
  border-radius: 5px !important;
  font-weight: 600 !important;
  font-size: 18px !important;
  padding: 10px 18px !important;
  cursor: pointer;
}
.btn-success:disabled {
  background-color: rgb(204, 203, 203) !important;
  cursor: not-allowed !important;
  border: none !important;
}
.btn-success {
  font-size: 14px !important;
  color: #ffffff !important;
  border: 1px solid #299541 !important;
}

.nutrional-info-button {
  background-color: #ff611d !important;
  font-size: 10px !important;
  padding: 5px !important;
  text-transform: capitalize !important;
}

.btn-primary-font {
  font-size: 16px;
}

.btn-secondary-title {
  font-size: 14px !important;
}

.padding-y-2 {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.padding-y-3 {
  padding-top: 0.3rem !important;
  padding-bottom: 0.3rem !important;
}

.margin-y-1 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.spice-btn {
  border: 1px solid #c4c4c4 !important;
  border-radius: 8px;
  padding: 6px !important;
  text-transform: capitalize !important;
}

.btn-auth {
  margin: 30px 0 !important;
  width: 100%;
  padding: 13px 0px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  font-family: "Montserrat", "Roboto", "sans-serif" !important;
  border: 1px solid transparent !important;
}
.btn-auth:disabled {
  background-color: rgb(204, 203, 203) !important;
  cursor: not-allowed !important;
  border: none !important;
}

.small-size-button {
  font-size: 12px !important;
  border: 1px solid #ff611d !important;
  padding: 8px 10px !important;
}

.add-item-btn {
  font-size: 12px !important;
  background-color: #FF8908 !important;
  border: 1px solid #FF8908 !important;
  text-transform: capitalize;
  padding: 5px 13px !important;
}

@media only screen and (max-width: 400px) {
  .d-block {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/app-button/app-button.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAiBA;EAdE,iDCuEuB;EDtEvB,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,6BAAA;EACA,eAAA;AACF;AACE;EACE,+CAAA;EACA,8BAAA;EACA,uBAAA;AACJ;AAGA;EAEE,oCAAA;EACA,yBAAA;EACA,oCAAA;AAFF;;AAKA;EArBE,iDCuEuB;EDtEvB,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,6BAAA;EACA,eAAA;AAoBF;AAlBE;EACE,+CAAA;EACA,8BAAA;EACA,uBAAA;AAoBJ;AATA;EAEE,oCAAA;EACA,yBAAA;EACA,oCAAA;AAUF;;AAPA;EA5BE,iDCuEuB;EDtEvB,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,6BAAA;EACA,eAAA;AAuCF;AArCE;EACE,+CAAA;EACA,8BAAA;EACA,uBAAA;AAuCJ;AArBA;EAGE,oCAAA;EACA,yBAAA;EACA,oCAAA;AAqBF;;AAlBA;EACE,oCAAA;EArCA,iDCuEuB;EDtEvB,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,6BAAA;EACA,eAAA;AA2DF;AAzDE;EACE,+CAAA;EACA,8BAAA;EACA,uBAAA;AA2DJ;AAjCA;EAGE,0BAAA;EACA,yBAAA;EACA,oCAAA;AAiCF;;AA9BA;EACE,oCAAA;EACA,0BAAA;EACA,uBAAA;EACA,qCAAA;AAiCF;;AA9BA;EACE,eCNc;ADuChB;;AA9BA;EACE,0BAAA;AAiCF;;AA9BA;EACE,2BAAA;EACA,8BAAA;AAiCF;;AA7BA;EACE,8BAAA;EACA,iCAAA;AAgCF;;AA7BA;EACE,2BAAA;EACA,8BAAA;AAgCF;;AA7BA;EACE,oCAAA;EACA,kBAAA;EACA,uBAAA;EACA,qCAAA;AAgCF;;AA7BA;EACE,yBAAA;EACA,WAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4DAAA;EACA,wCAAA;AAgCF;AA9BE;EACE,+CAAA;EACA,8BAAA;EACA,uBAAA;AAgCJ;;AA3BA;EACE,0BAAA;EACA,oCAAA;EACA,4BAAA;AA8BF;;AA3BA;EACE,0BAAA;EACA,oCAAA;EACA,oCAAA;EACA,0BAAA;EACA,4BAAA;AA8BF;;AA3BA;EACE;IACE,sBAAA;EA8BF;AACF","sourcesContent":["@import '../../styles/variables';\n\n@mixin btn-same-properties {\n  font-family: $font-family-montserrat;\n  border-radius: $border-radius-5 !important;\n  font-weight: $font-weight-600 !important;\n  font-size: $heading-18 !important;\n  padding: 10px 18px !important;\n  cursor: pointer;\n\n  &:disabled {\n    background-color: rgb(204, 203, 203) !important;\n    cursor: not-allowed !important;\n    border: none !important;\n  }\n}\n\n.btn-orange {\n  @include btn-same-properties;\n  background-color: $primary-color !important;\n  color: $white-color !important;\n  border: 1px solid $primary-color !important;\n}\n\n.btn-orange-outline {\n  @include btn-same-properties;\n  background-color: $white-color !important;\n  color: $primary-color !important;\n  border: 1px solid $primary-color !important;\n}\n\n.btn-black {\n  @include btn-same-properties;\n\n  background-color: $secondary-color !important;\n  color: $white-color !important;\n  border: 1px solid $secondary-color !important;\n}\n\n.btn-success {\n  background-color: #299541 !important;\n  @include btn-same-properties;\n  font-size: $secondary-title !important;\n  color: $white-color !important;\n  border: 1px solid #299541 !important;\n}\n\n.nutrional-info-button {\n  background-color: $primary-color !important;\n  font-size: $title-10 !important;\n  padding: 5px !important;\n  text-transform: capitalize !important;\n}\n\n.btn-primary-font {\n  font-size: $primary-title;\n}\n\n.btn-secondary-title {\n  font-size: $secondary-title !important;\n}\n\n.padding-y-2 {\n  padding-top: 2px !important;\n  padding-bottom: 2px !important;\n}\n\n\n.padding-y-3 {\n  padding-top: 0.3rem !important;\n  padding-bottom: 0.3rem !important;\n}\n\n.margin-y-1 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.spice-btn {\n  border: 1px solid $icon-color !important;\n  border-radius: 8px;\n  padding: 6px !important;\n  text-transform: capitalize !important;\n}\n\n.btn-auth {\n  margin: 30px 0 !important;\n  width: 100%;\n  padding: 13px 0px !important;\n  font-size: $secondary-title !important;\n  font-weight: $font-weight-600 !important;\n  font-family: $font-family-montserrat !important;\n  border: 1px solid transparent !important;\n\n  &:disabled {\n    background-color: rgb(204, 203, 203) !important;\n    cursor: not-allowed !important;\n    border: none !important;\n\n  }\n}\n\n.small-size-button {\n  font-size: $tertiary-title !important;\n  border: 1px solid $primary-color !important;\n  padding: 8px 10px !important;\n}\n\n.add-item-btn {\n  font-size: $tertiary-title !important;\n  background-color: #FF8908 !important;\n  border: 1px solid #FF8908 !important;\n  text-transform: capitalize;\n  padding: 5px 13px !important;\n}\n\n@media only screen and (max-width:400px) {\n  .d-block {\n    width: 100% !important;\n  }\n\n}","// all color, text-sizes, border-radius etc  should be initialize here as variables and use them in styling\n// do not write explicitly values.\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n//colors\n$primary-color: #ff611d;\n$secondary-color: #333333;\n\n$black-color: #000000;\n$white-color: #ffffff;\n$dark-gray-color: #3c3c3c;\n$grey-color: #747070;\n$orange-color: #ff8908;\n$yellow-color: #ffb80e;\n$link-color: #59a9ff;\n$orange-yellowish-color: #ffa412;\n$mid-green-color: #00d27a;\n$apple-green-color:#659c35;\n$dark-white-smoke-color: #f5f8fe;\n$mix-grey-color: linear-gradient(180deg, #464c52 0%, #464c5299 100%);\n$orange-color-300: #FFA300;\n\n$solitude-color:#E9EFFD;\n$error-color: #dc3545;\n$alert-text-color:#81222C;\n$success-color: #165c27;\n$alertgreen-color: #d0e7d6;\n$alertred-color:#F7D5D8;\n$selected-tap-color: #1c1b1b;\n$rate-star-color: #ffce31;\n$icon-color: #c4c4c4;\n$selected-field-color: #6c757d;\n$hover-color: #fee6dd;\n$blue_magenta_color: #EBEBEE;\n$green-color:#40d698;\n$light-gray-color:#9d99b9;\n$mid-gray: #676c70;\n\n//font-size\n$primary-heading: 32px;\n$secondary-heading: 24px;\n$tertiary-heading: 28px;\n$heading-48: 48px;\n$heading-42: 42px;\n$heading-20: 20px;\n$heading-22: 22px;\n$heading-18: 18px;\n\n$primary-title: 16px;\n$secondary-title: 14px;\n$tertiary-title: 12px;\n$title-15: 15px;\n$title-13: 13px;\n$title-10: 10px;\n\n//border-radius\n$border-radius-4: 4px;\n$border-radius-5: 5px;\n$border-radius-10: 10px;\n$border-radius-15: 15px;\n$border-radius-20: 20px;\n$border-radius-rounded:50%;\n\n//font-weight\n$font-weight-300: 300;\n$font-weight-400: 400;\n$font-weight-500: 500;\n$font-weight-600: 600;\n$font-weight-700: 700;\n$font-weight-800: 800;\n$font-weight-900: 900;\n\n//font-family\n$font-family-montserrat: \"Montserrat\", \"Roboto\", \"sans-serif\";\n$font-family-roboto: \"Roboto\", \"sans-serif\", \"Montserrat\";"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
